import React from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';
import { ISSUE_CATEGORIES } from '../../types/quality';
import { Percent } from './Percent';
/** How many of a category's top rules to list inside its panel. */
var TOP_RULES_PER_PANEL = 3;
var CATEGORY_ICON = {
    STRUCTURAL: '🏗️',
    VOCABULARY: '📖',
    MARC_LOGIC: '🔧',
};
var panelsStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: '14px',
    marginBottom: '22px',
};
var panelStyle = {
    border: '1px solid #d4dbe3',
    borderRadius: '10px',
    padding: '14px 16px',
    background: '#fff',
};
var complianceColor = function (pct) {
    if (pct >= 95)
        return '#1b7f43';
    if (pct >= 80)
        return '#9a6b00';
    return '#a4123f';
};
/**
 * The three AV-03 validation-layer panels (Strukturální / Slovníková / MARC
 * pravidla). Each shows the % of records that comply with that layer, the
 * violation / affected-record counts, and the layer's top failing rules with a
 * drill-through to the records list (scenario step 6).
 */
export var CategoryPanels = function (_a) {
    var detail = _a.detail, onDrillToRule = _a.onDrillToRule;
    var byCategory = new Map(detail.categories.map(function (c) { return [c.category, c]; }));
    var topByCategory = new Map();
    ISSUE_CATEGORIES.forEach(function (cat) {
        topByCategory.set(cat, detail.topRules.filter(function (r) { return r.category === cat; }).slice(0, TOP_RULES_PER_PANEL));
    });
    return (React.createElement("div", { style: panelsStyle, "data-test-category-panels": true }, ISSUE_CATEGORIES.map(function (cat) {
        var _a, _b, _c, _d, _e, _f, _g;
        var stats = byCategory.get(cat);
        var compliance = (_a = stats === null || stats === void 0 ? void 0 : stats.compliancePercent) !== null && _a !== void 0 ? _a : 100;
        var topRules = (_b = topByCategory.get(cat)) !== null && _b !== void 0 ? _b : [];
        return (React.createElement("section", { key: cat, style: panelStyle, "data-test-category-panel": cat },
            React.createElement("h3", { style: { margin: '0 0 8px', fontSize: '14px', fontWeight: 700 } },
                React.createElement("span", { "aria-hidden": true, style: { marginRight: '6px' } }, CATEGORY_ICON[cat]),
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.category.".concat(cat) })),
            React.createElement("div", { style: { fontSize: '28px', fontWeight: 700, color: complianceColor(compliance) } },
                React.createElement(Percent, { value: compliance })),
            React.createElement("div", { style: { fontSize: '12px', color: '#5d6b7a', marginBottom: '10px' } },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.category.compliance" })),
            React.createElement("div", { style: { fontSize: '12.5px', color: '#43525f', marginBottom: '10px' } }, ((_c = stats === null || stats === void 0 ? void 0 : stats.records) !== null && _c !== void 0 ? _c : 0) === ((_d = stats === null || stats === void 0 ? void 0 : stats.violations) !== null && _d !== void 0 ? _d : 0) ? (React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.category.records", values: { records: React.createElement(FormattedNumber, { value: (_e = stats === null || stats === void 0 ? void 0 : stats.records) !== null && _e !== void 0 ? _e : 0 }) } })) : (React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.category.counts", values: {
                    records: React.createElement(FormattedNumber, { value: (_f = stats === null || stats === void 0 ? void 0 : stats.records) !== null && _f !== void 0 ? _f : 0 }),
                    violations: React.createElement(FormattedNumber, { value: (_g = stats === null || stats === void 0 ? void 0 : stats.violations) !== null && _g !== void 0 ? _g : 0 }),
                } }))),
            topRules.length > 0 ? (React.createElement("ul", { style: { margin: 0, paddingLeft: '16px', fontSize: '12.5px' } }, topRules.map(function (r) { return (React.createElement("li", { key: r.code, style: { marginBottom: '3px' } },
                React.createElement("button", { type: "button", onClick: function () { return onDrillToRule(r.code); }, "data-test-category-rule": r.code, style: {
                        background: 'none',
                        border: 'none',
                        padding: 0,
                        cursor: 'pointer',
                        color: '#2c5cc5',
                        font: 'inherit',
                        textDecoration: 'underline',
                        textAlign: 'left',
                    } },
                    React.createElement("span", { "data-test-category-rule-label": true }, r.label || r.code)),
                React.createElement("span", { style: { color: '#5d6b7a' } },
                    " (",
                    React.createElement(FormattedNumber, { value: r.records }),
                    ")"))); }))) : (React.createElement("div", { style: { fontSize: '12.5px', color: '#5d6b7a' } },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.corpusQuality.category.noFailures" })))));
    })));
};
